module.exports = __webpack_public_path__ + "img/class-dojo.cd08733f.png";